import {Formik, Form} from 'formik'
import * as Yup from 'yup'
import FormikControl from '../../../components/formikControl/FormikControl'
import toast from 'react-hot-toast'
import {createStudent, updateStudent} from './api'
import {fetchShiftList} from '../shift/api'
import {fetchClassList} from '../class/api'
import {fetchDivisionList} from '../division/api'
import {useQueries} from 'react-query'
import {RunnerBall} from '../../../components/FormLoader'
import {checkIsoAndReturnYMDFormat} from '../../../helpers/dateFunctions'
import {handleApiError} from '../../../helpers/errorHandler'
import {Col, Row} from 'react-bootstrap'
import FormResetBtn from '../../../components/FormResetBtn'
import FormSubmitBtn from '../../../components/FormSubmitBtn'
import {fetchSubSchoolDetails} from '../profile/api'

function StudentForm({initialValues, onAfterSubmit}) {
  const formType = initialValues ? 'update' : 'add'

  const calls = [
    {queryKey: 'shift', queryFn: fetchShiftList, initialValues: [], refetchOnWindowFocus: false},
    {queryKey: 'class', queryFn: fetchClassList, initialValues: [], refetchOnWindowFocus: false},
    {
      queryKey: 'division',
      queryFn: fetchDivisionList,
      initialValues: [],
      refetchOnWindowFocus: false,
    },
    {
      queryKey: 'subschools',
      queryFn: fetchSubSchoolDetails,
      initialValues: [],
      refetchOnWindowFocus: false
    },
  ]
  const results = useQueries(calls)

  if (results[0].isFetching || results[1].isFetching || results[2].isFetching || results[3].isFetching) {
    return <RunnerBall />
  }

  const shiftList = results[0]?.data?.data
  const classList = results[1]?.data?.data
  const divisionList = results[2]?.data?.data
  const subschoolList = results[3]?.data?.data

  const submitHandler = (values, {setSubmitting: setLoading}) => {
    if (!values.dob) {
      values.dob = null
    }

    setLoading(true)
    const toastId = toast.loading('Submitting')
    const action = formType === 'add' ? createStudent : updateStudent
    action(values)
      .then(() => {
        toast.success('Success', {id: toastId})
        onAfterSubmit()
      })
      .catch((err) => {
        handleApiError(err, toastId)
      })
      .then((res) => setLoading(false))
  }

  if (formType === 'update') {
    initialValues.class_name = initialValues.class
    initialValues.dob = checkIsoAndReturnYMDFormat(initialValues.dob)
  }

  const formValues = initialValues || {
    student_name: '',
    class_name: '',
    division: '',
    student_status: '',
    shift_id: '',
    gender: '',
    roll_number: '',
    dob: '',
    regID: '',
    sub_school_id:''
    // pickUpNotificationTime: '',
    // dropNotificationTime: '',
  }

  return (
    <div className="px-5 py-3">
      <Formik
        initialValues={formValues}
        validationSchema={Yup.object({
          student_name: Yup.string()
            .max(100, 'The Student name cannot exceed 100 characters')
            .required(),
          class_name: Yup.string().required('Grade is required'),
          division: Yup.string().required('Division is required'),
          student_status: Yup.string().required('Status is required'),
          shift_id: Yup.string().required('Shift is required'),
          gender: Yup.string(),
          roll_number: Yup.string(),
          sub_school_id: Yup.string().required('Sub School ID is required'),
          dob: Yup.date()
            .test('is-4-digit-year', 'Year must be a 4-digit number', (value) => {
              if (!value) return true
              const year = value.getFullYear()
              return year >= 1000 && year <= 9999
            })
            .nullable(),
          regID: Yup.string().required(),
          // pickUpNotificationTime: Yup.number().required(),
          // dropNotificationTime: Yup.number().required(),
        })}
        onSubmit={submitHandler}
      >
        {({isSubmitting, resetForm, values, dirty, isValid}) => (
          <Form>
            <Row>
              <FormikControl
                control="input"
                required
                placeholder="Student Name"
                label="Student Name"
                name="student_name"
              />

              <FormikControl
                control={'select-advanced'}
                options={classList}
                placeholder="Grade"
                label="Grade"
                name="class_name"
                value={classList.find((cls) => cls.class_name === values.class_name) || ''}
                optionLabel={'class_name'}
                optionValue={'class_name'}
                required
              />
              <FormikControl
                control={'select-advanced'}
                options={divisionList}
                placeholder="Division"
                label="Division"
                name="division"
                value={divisionList.find((div) => div.division_name === values.division) || ''}
                optionLabel={'division_name'}
                optionValue={'division_name'}
                required
              />
              <FormikControl
                control={'select-advanced'}
                options={shiftList}
                placeholder="Shift"
                label="Shift"
                name="shift_id"
                value={shiftList.find((shift) => shift.shift_id === values.shift_id) || ''}
                optionLabel={'shift_name'}
                optionValue={'shift_id'}
                required
              />
              <FormikControl
                control={'select-advanced'}
                options={subschoolList}
                placeholder="Sub School ID"
                label="Sub School ID"
                name="sub_school_id"
                value={subschoolList.find((school) => school.sub_school_id === values.sub_school_id) || ''}
                optionLabel={'sub_school_name'}
                optionValue={'sub_school_id'}
                required
              />
              <Col sm="6">
                <FormikControl
                  control="input"
                  placeholder="Seat Number"
                  label="Seat Number"
                  name="roll_number"
                />
              </Col>
              <Col sm="6">
                <FormikControl
                  control="input"
                  required
                  placeholder="Reg ID"
                  label="Reg ID"
                  name="regID"
                />
              </Col>
              {/* <Col sm="6">
                <FormikControl
                  control="input"
                  type="number"
                  required
                  placeholder="Pick Up Notification Time"
                  label="Pick Up Notification Time"
                  name="pickUpNotificationTime"
                />
              </Col> */}
              {/* <Col sm="6">
                <FormikControl
                  control="input"
                  type="number"
                  required
                  placeholder="Drop Notification Time"
                  label="Drop Notification Time"
                  name="dropNotificationTime"
                />
              </Col> */}
              <FormikControl control="input" type="date" placeholder="DOB" label="DOB" name="dob" />
              <Col sm="6">
                <FormikControl
                  control="check"
                  type="radio"
                  options={[
                    {key: 'Male', value: 'male'},
                    {key: 'Female', value: 'female'},
                  ]}
                  placeholder="Gender"
                  label="Gender"
                  name="gender"
                />
              </Col>
              <Col sm="6">
                <FormikControl
                  control="check"
                  type="radio"
                  options={[
                    {key: 'Active', value: '1'},
                    {key: 'Inactive', value: '0'},
                  ]}
                  required
                  placeholder="Active Status"
                  label="Active Status"
                  name="student_status"
                />
              </Col>
              <div className="text-center pt-10">
                <FormResetBtn onClick={() => resetForm} disabled={isSubmitting} className="me-4" />

                <FormSubmitBtn disabled={!dirty || !isValid || isSubmitting} />
              </div>
            </Row>
          </Form>
        )}
      </Formik>
    </div>
  )
}

export default StudentForm
